'use client';

import { useAuth } from '@/contexts';
import { UserRole } from '@/types';
import { Typography, Box, Button } from '@mui/material';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';

interface RoleGuardProps {
  roles: UserRole[];
  children: React.ReactNode;
}

export const RoleGuard = ({ roles, children }: RoleGuardProps) => {
  const { user, isAuthenticated } = useAuth();
  const t = useTranslations('roleGuard');
  const router = useRouter();

  if (!isAuthenticated || !user) return null;

  const hasRole = user.role && roles.includes(user.role);

  if (!hasRole) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          gap: 2,
          textAlign: 'center',
          px: 2,
        }}
      >
        <Typography variant="h4" fontWeight={700}>
          {t('title')}
        </Typography>
        <Typography variant="body1" color="text.secondary" maxWidth={480}>
          {t('description')}
        </Typography>
        <Button variant="contained" onClick={() => router.back()}>
          {t('backButton')}
        </Button>
      </Box>
    );
  }

  return <>{children}</>;
};
